import React from "react";
import { fixedTwo } from "../../common-data/Converts";

const DietDays = ({ formValues }) => {
  return (
    <div className="sub-form-container view-details-form">
      <div className="headinNbutton">
        <h2 className="sub-heading">Diet Plans</h2>
      </div>

      {Array.isArray(formValues) && formValues?.length > 0
        ? formValues.map((dayForm, dayIndex) => (
            <div className="sub-section" key={dayIndex}>
              <span className={`tagline `}>
                {dayForm.mealTagline?.replace(/_/g, " ")}
                {dayForm.mealTagline === "breakfast" ||
                dayForm.mealTagline === "lunch" ||
                dayForm.mealTagline === "snacks" ||
                dayForm.mealTagline === "dinner" ? (
                  <span className="impMark">*</span>
                ) : null}
              </span>

              <div className="selected-multi-box">
                {dayForm.meals
                  ? dayForm.meals.map((meal, mealIndex) => {
                      return (
                        <div className="flex-box" key={mealIndex}>
                          <div className="formInputBox longOne">
                            <label
                              htmlFor={`selectedMeal`}
                              className="formInputLabel"
                            >
                              Selected Meal *
                            </label>

                            <input
                              type="email"
                              className="formInput"
                              name="email"
                              placeholder={`${
                                meal.selectedMeal?.label || "🚫 NA"
                              }`}
                              disabled
                            />

                            <div className="sub-input-values">
                              {/* {dayForm.meals &&
                                dayForm.meals.length > 0 &&
                                dayForm.meals.map((meal, mealIndexS) => ( */}
                              <div className="flex-box">
                                <div className="formInputBox longOne">
                                  {/* {mealIndex === mealIndexS && ( */}
                                  <div className="sub-input-values">
                                    <span className="values">
                                      total cal-
                                      {meal.totalCalory?.totalCal
                                        ? fixedTwo(meal.totalCalory.totalCal)
                                        : 0}
                                    </span>
                                    <span className="values">
                                      protien-
                                      {meal.totalCalory?.protiens
                                        ? fixedTwo(meal.totalCalory.protiens)
                                        : 0}{" "}
                                      g
                                    </span>
                                    <span className="values">
                                      fat-
                                      {meal.totalCalory?.fats
                                        ? fixedTwo(meal.totalCalory.fats)
                                        : 0}{" "}
                                      g
                                    </span>
                                    <span className="values">
                                      carbs-
                                      {meal.totalCalory?.carbs
                                        ? fixedTwo(meal.totalCalory.carbs)
                                        : 0}{" "}
                                      g
                                    </span>
                                  </div>
                                  {/* )} */}
                                </div>
                              </div>
                              {/* ))} */}
                            </div>
                          </div>

                          <div className="formInputBox shortOne">
                            <label
                              htmlFor={`quantity`}
                              className="formInputLabel"
                            >
                              quantity *
                            </label>

                            <div className="commonWrapper inputs">
                              <input
                                type="quantity"
                                className="formInput"
                                name="quantity"
                                placeholder={`${meal.quantity || "🚫 0"}`}
                                disabled
                              />

                              <div className="grayInputLine"></div>

                              <span className="value">
                                {meal.selectedMeal?.info?.unit_name || "NA"}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>
          ))
        : null}
    </div>
  );
};

export default DietDays;
